
import { useStore } from "vuex";
import CartListItem from "../../../routes/shopping-cart/components/cart-item/cart-list-item/CartListItem.vue";

export default {
  components: { CartListItem },
  props: {
    cartItems: Object
  },
  setup() {
    const store = useStore();
    const hideModal = () => {
      store.dispatch("modals/hideModal", "CartListItem", { root: true });
    };

    return {
      hideModal
    };
  }
};
